import React from 'react';
import { Line } from 'react-chartjs-2';

const LineChart = ({ dataValue, optionsValue, ...rest }) => {
  return <Line data={dataValue} options={optionsValue} />;
};
export default LineChart;
